import { createApp, watch, ref } from 'vue'
import { createPinia } from 'pinia'
import Vue3Toastify, { toast } from 'vue3-toastify'
import VueTelInput from 'vue3-tel-input'
import VOtpInput from 'vue3-otp-input'
import 'vue3-tel-input/dist/vue3-tel-input.css'
import Vue3PersianDatetimePicker from 'vue3-persian-datetime-picker'
import App from './App.vue'
import '@/theming'
import router from './router'
import VueCookies from 'vue3-cookies'
import settings from './settings'
import '../sw'
import { createI18n } from 'vue-i18n'
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
import en from './locales/en.json'
import fa from './locales/fa.json'
import { createGtag } from 'vue-gtag'
import { User } from '@/logic/users/user/user'
import { filters } from '@/services/filters'
import { initAxios } from '@/services/axios'
import {
  initRouting,
  restoreScrollWithUseScroll,
  componentState,
  saveState,
  getState
} from '@/services/routing'
import { fileUtils, createNumberUtils, createTimeUtils } from '@/services/utils'
import ThemeIcon from '@/components/ThemeIcon.vue'

const app = createApp(App)
const pinia = createPinia()

const savedLocale = localStorage.getItem('user-locale') || 'fa'

export const i18n = createI18n({
  locale: savedLocale,
  fallbackLocale: 'en',
  messages: {
    en: en,
    fa: fa
  },
  silentTranslationWarn: true,
  silentFallbackWarn: true
})

app.use(VueViewer, {
  defaultOptions: {
    zoomRatio: 0.4
  }
})

app.use(i18n)

const gtag = createGtag({
  tagId: 'G-L58YEX5JK6',
  pageTracker: { router },
  config: {
    params: { debug_mode: false }
  }
})

app.use(Vue3Toastify, {
  autoClose: 3000,
  position: toast.POSITION.TOP_CENTER,
  theme: toast.THEME.COLORED
})
app.use(VueTelInput)

const localeDirections = {
  fa: 'rtl',
  en: 'ltr'
}

watch(
  () => i18n.global.locale,
  (newLocale) => {
    const direction = localeDirections[newLocale] || 'ltr'
    document.documentElement.setAttribute('dir', direction)
  },
  { immediate: true }
)

app.use(Vue3PersianDatetimePicker, {
  name: 'CustomDatePicker',
  props: {
    format: 'YYYY-MM-DD HH:mm',
    displayFormat: 'jYYYY-jMM-jDD',
    editable: false,
    inputClass: 'form-control my-custom-class-name',
    placeholder: 'Please Select a date',
    altFormat: 'YYYY-MM-DD HH:mm',
    color: '#00acc1',
    autoSubmit: false
  }
})

app.config.globalProperties.$filters = filters

const { axios_include_timezone } = initAxios({
  app,
  router,
  pinia,
  i18n,
  settings
})

const { historyMixin } = initRouting({
  router,
  app,
  settings,
  filters,
  User
})

export const numberUtils = createNumberUtils(filters)
export const timeUtils = createTimeUtils(i18n)

app.mixin(historyMixin)

app.use(pinia)
app.use(router)
app.use(gtag)
app.use(VueCookies)
app.component('VOtpInput', VOtpInput)
app.component('ThemeIcon', ThemeIcon)

app.provide('axios', app.config.globalProperties.axios)
app.provide('axios_include_timezone', app.config.globalProperties.axios_include_timezone)

User.getMe().catch(() => {})

app.mount('#app')

const primePhoneNumber = '+971 58 865 9809'

export { axios_include_timezone }
export { primePhoneNumber }
export { filters }
export { fileUtils, componentState, saveState, getState, restoreScrollWithUseScroll, historyMixin }
export default app
